"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLastNWindow = exports.lastNDateWindow = void 0;
var core_1 = require("../core");
var trimMetricTable_1 = require("../trimMetricTable");
var lastNDateWindow = function (numberOfPoints) {
    return function (table) { return (0, trimMetricTable_1.trimMetricTable)(table, numberOfPoints); };
};
exports.lastNDateWindow = lastNDateWindow;
var createLastNWindow = function (n) {
    return {
        type: core_1.DateWindowTypes.LAST_N,
        n: n,
    };
};
exports.createLastNWindow = createLastNWindow;
//# sourceMappingURL=lastNDateWindow.js.map